import React, { FC, ReactElement } from 'react'
import ButtonGradientEpic from '@/components/button-gradient-epic'
import Button from '@/components/button'
import useWallet from '@/utils/hooks/useWallet'
import { selectBrc20ListTransfers } from '@/utils/fungible-transfer'
import InscriptionCard from './inscription-card'
import formatNumber from '@/utils/format-number'

const BRC20List: FC<{
	onComplete: () => void
	setTab: (id: string) => void
	ticker: string
	slug?: string
}> = (props): ReactElement => {
	const { ticker, slug, setTab, onComplete } = props
	const { data, isLoading } = useWallet()

	const transfers = React.useMemo(
		() => selectBrc20ListTransfers(data?.inscriptions, { ticker, slug }),
		[data, ticker, slug]
	)

	const renderTransfer = React.useCallback(
		(e: any, i: any) => {
			return (
				<InscriptionCard
					inscription={e}
					onList={() => {}}
					onTransfer={() => {}}
					key={i}
					ticker={ticker}
					description={formatNumber(`${e.amount}`) as any}
					collection={e.collection}
				></InscriptionCard>
			)
		},
		[ticker]
	)

	return (
		<>
			<p className="flex justify-center w-full text-base font-bold">Transfer Inscriptions</p>
			{!isLoading && !transfers.length && (
				<div className="bg-card p-4 flex flex-col gap-4 rounded-xl border border-border">
					<p className="text-muted-foreground text-sm text-center ">
						You will need to inscribe a transfer inscription to list for sale or transfer to another
						wallet.
					</p>
					<ButtonGradientEpic className="rounded-full h-[42px]" onClick={() => setTab('transfer')}>
						Inscribe transfer
					</ButtonGradientEpic>
				</div>
			)}
			{!!transfers.length && (
				<div className="bg-card p-4 flex flex-col gap-4 rounded-xl border border-border">
					{transfers.map(renderTransfer)}
				</div>
			)}
			<Button
				className="text-muted-foreground rounded-full text-base font-semibold p-0 h-12"
				onClick={onComplete}
			>
				Close
			</Button>
		</>
	)
}

export default BRC20List
